var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSun = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M10 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.5,
  x: 9,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.5,
  x: 9,
  y: 16.5,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.5,
  x: 17.25,
  y: 8.25,
  rx: 1,
  transform: "rotate(90 18.25 10)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.5,
  x: 0.75,
  y: 8.25,
  rx: 1,
  transform: "rotate(90 1.75 10)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.5,
  x: 14.834,
  y: 2.416,
  rx: 1,
  transform: "rotate(45 15.834 4.166)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.5,
  x: 3.166,
  y: 14.084,
  rx: 1,
  transform: "rotate(45 4.166 15.834)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.5,
  x: 14.834,
  y: 14.084,
  rx: 1,
  transform: "rotate(135 15.834 15.834)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.5,
  x: 3.166,
  y: 2.416,
  rx: 1,
  transform: "rotate(135 4.166 4.166)"
}))));
export default SvgIconSun;